import { render, staticRenderFns } from "./student-unpaid.vue?vue&type=template&id=ba42091e"
import script from "./student-unpaid.vue?vue&type=script&lang=js"
export * from "./student-unpaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports